// extracted by mini-css-extract-plugin
module.exports = {"footerToolbar":"_3G45H","footerToolbar_buttons":"_3H3Xw","footerToolbarButtons":"_3H3Xw","wrapper":"jY4S3","desktop":"_24vdc","editor":"_2YWoo","atomic":"_3lLle"};